import { FC } from "react";

type Props = {
  name: string;
  className?: string;
  size?: string;
};

const Icon: FC<Props> = ({ name, className, size }) => {
  return (
    <span
      className={"abb-icon " + name + " " + className}
      style={{ fontSize: size }}
    />
  );
};

export default Icon;
